/**
 * Copyright (c) 2026 Constructor Technology AG. All rights reserved.
 *
 * Proprietary and confidential. Unauthorized copying, distribution, or use
 * is prohibited.
 *
 * SPDX-License-Identifier: LicenseRef-Constructor-Proprietary
 */

import {
  ADD,
  REMOVE,
} from './mutation-types';

export default {
  [ADD](state, payload) {
    state.items = payload;
  },
  [REMOVE](state, payload) {
    state.items = payload;
  },
};
